import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

// TODO: update styles
import styles from '../../styles/views/components/Dropdown.module.scss';

const dropdownFont = {
  fontSize: '16px',
  color: styles.colorAztec,
  fontFamily: styles.fontFamilyMain,
};

const MultipleDropdown = ({
  name,
  label,
  placeholder,
  options,
  defaultValue,
  onChange,
  refs,
}) => {
  const isMulti = true;
  const isSearchable = true;
  const isClearable = false;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const customStyles = {
    container: defaultStyles => ({
      ...defaultStyles,
      width: '100%',
      marginTop: label ? '-11px' : 0,
      padding: '0',
    }),
    control: (defaultStyles, state) => ({
      ...defaultStyles,
      ...dropdownFont,
      width: '100%',
      display: 'flex',
      backgroundColor: !state.isDisabled ? styles.colorWhite : styles.colorAlabaster,
      border: 'none',
      boxSizing: 'border-box',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
      borderRadius: 0,
    }),
    placeholder: defaultStyles => ({
      ...defaultStyles,
      ...dropdownFont,
      color: isSearchable ? styles.colorAlto : styles.colorAztec,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    }),
    menu: defaultStyles => ({
      ...defaultStyles,
      borderRadius: 0,
      boxSizing: 'content-box',
      boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.05)',
      border: `1px solid ${styles.colorAztec}`,
      width: '100%',
      margin: '0 0 0 -1px',
      zIndex: 2,
    }),
    menuList: defaultStyles => ({
      ...defaultStyles,
      padding: 0,
      maxHeight: '120px',
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: styles.colorAlabaster,
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: styles.colorAlto,
      },
    }),
    option: (defaultStyles, state) => ({
      ...defaultStyles,
      ...dropdownFont,
      backgroundColor: state.isFocused ? styles.colorAlabaster : styles.colorWhite,
      padding: '10px 11px',
      color: state.isDisabled ? styles.colorDustyGray : styles.colorAztec,
    }),
    dropdownIndicator: (defaultStyles, state) => ({
      ...defaultStyles,
      color: !state.isDisabled ? styles.colorAztec : styles.colorAlto,
      transition: 'all .2s ease',
      transform: isMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    }),
    singleValue: defaultStyles => ({
      ...defaultStyles,
      ...dropdownFont,
    }),
  };

  return (
    <div style={{ height: 'auto' }} className={styles.container}>
      <fieldset style={{ height: 'auto' }} className={!label ? styles.noLabel : ''}>
        {label && <legend>{label}</legend>}
        <Select
          ref={node => refs.push(node)}
          name={name}
          styles={customStyles}
          placeholder={placeholder}
          options={options}
          defaultValue={defaultValue}
          onChange={onChange}
          isMulti={isMulti}
          isClearable={isClearable}
          isSearchable={isSearchable}
          onMenuOpen={() => setIsMenuOpen(true)}
          onMenuClose={() => setIsMenuOpen(false)}
          components={{ IndicatorSeparator: () => null }}
        />
      </fieldset>
    </div>
  );
};

MultipleDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  defaultValue: PropTypes.oneOfType([
    PropTypes.instanceOf(null),
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  refs: PropTypes.array,
};

MultipleDropdown.defaultProps = {
  label: '',
  placeholder: '',
  refs: [],
};

export default MultipleDropdown;
